export default "__VITE_ASSET__ffZ1QZp0__"